module.exports = __webpack_public_path__ + "static/media/chi_logo_89px.8628d1b7.png";